<template>
    <div>
        <pre>{{ test.$state }}</pre>
        <textarea v-model="object" rows="10"></textarea>
        <button @click="update">Submit</button>
        <pre>{{ object }}</pre>
    </div>
</template>

<script setup>
import { computed, reactive } from 'vue';
import { useTestStore } from '@/stores/test'

const test = useTestStore()

const data = reactive({ object: {}, country: { name: 'Tom'}})

const parseJson = json => {
    try {
        return JSON.parse(json)
    } catch(err) {
        return null
    }
}

const object = computed({
    get: () => JSON.stringify(data.object, null, 2),
    set: value => {
        const json = parseJson(value)
        if(json) data.object = json
    }
})

const update = () => {
    test.$state = data.object
}

const clear = () => {
    test.clear()
}
</script>
